export default "__VITE_ASSET__D8osj_r4__"